module.exports = __webpack_public_path__ + "media/img/vca/sponsors/bhmedicalaeshtetics-7bc060160ce21e5ab3051653b09ecd64.png";